import { render, staticRenderFns } from "./SidebarDefault.vue?vue&type=template&id=67925653&"
import script from "./SidebarDefault.vue?vue&type=script&lang=js&"
export * from "./SidebarDefault.vue?vue&type=script&lang=js&"
import style0 from "./SidebarDefault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports